import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UsuarioService } from '../../containers/bandeja-principal/administrador/configuracion/usuario/usuario.service';

@Component({
  selector: 'app-modal-consultar-usuario',
  templateUrl: './modal-consultar-usuario.component.html',
  styleUrls: ['./modal-consultar-usuario.component.scss']
})
export class ModalConsultarUsuarioComponent implements OnInit {

  @Input()
	mensaje: string;
  form: FormGroup;
  valid: boolean = false;
  users: any[]=[];
	constructor(public activeModal: NgbActiveModal,
              private fb:FormBuilder,
              private UsuarioService: UsuarioService) { 
    this.initForm();
  }

	ngOnInit() {
	}

  initForm(): void{
    this.form = this.fb.group({
      valor: [null,[Validators.required]]
    })
  }
	confirm(): void {
		if (this.activeModal) {
			this.activeModal.close(this.form.value);
		}
	}
  verifyValid(){
    this.valid = this.users.some(x=>x.usuario == this.form.value.valor);
  }
  onChangeSearch(value:string): void{
    if(value.length > 2){
      this.UsuarioService 
          .filterUser(
            {
              ...this.form.value,
              tipo_usuario_id : 3
            }
            )
          .subscribe(response=>{
            if(response.result){
              this.users = response.data;
              this.verifyValid();
            }else{
              this.users=[];
            }
            
          })
    }
    
  }
}
